import React from "react";
import { EventType } from "./progressData";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/util/cn";

type EventSelectorProps = {
  eventTypes: EventType[];
  selectedEvent: EventType | null;
  setSelectedEvent: (event: EventType | null) => void;
  className?: string;
};

export default function EventSelector({
  eventTypes,
  selectedEvent,
  setSelectedEvent,
  className,
}: EventSelectorProps) {
  return (
    <Select
      value={selectedEvent ?? EventType.ALL}
      onValueChange={(value) => setSelectedEvent(value as EventType)}
    >
      <SelectTrigger className={cn("w-[160px] capitalize rounded-full bg-[#24262e] border-none text-brand-orange-500 text-xs px-4 py-1 h-8 focus:ring-0 shadow-md flex justify-between items-center", className)}>
        <SelectValue placeholder="information" />
      </SelectTrigger>
      <SelectContent className="bg-[#353945] border border-brand-neutral-600 rounded-xl overflow-hidden shadow-xl">
        <SelectGroup className="p-0">
          {eventTypes.map((event) => (
            <SelectItem
              key={event}
              value={event}
              className={cn(
                "capitalize px-4 py-3 flex justify-center border-b border-brand-neutral-600/50 last:border-b-0 cursor-pointer text-sm hover:bg-white/5",
                selectedEvent === event ? "text-brand-orange-500 font-medium" : "text-brand-neutral-400"
              )}
            >
              <div className="w-full text-center">{event}</div>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
